import React, { PureComponent } from 'react';
import { Form, Select, message } from 'antd';
import get from 'lodash/get';
import Modal from '../../../../../components/Modal';
import { updateBookingTags } from '../api';
import BookingPageContext from '../../../context';

const { Option } = Select;

const parseTagValue = (tag) => {
  if (Array.isArray(tag)) return tag.flatMap(parseTagValue);
  if (typeof tag !== 'string') return [];

  const trimmedTag = tag.trim();
  if (!trimmedTag) return [];

  try {
    const parsedTag = JSON.parse(trimmedTag);
    return parseTagValue(parsedTag);
  } catch (error) {
    return [trimmedTag];
  }
};

const normalizeTags = (tags = []) => [...new Set(parseTagValue(tags))];

class TagsModal extends PureComponent {
  static contextType = BookingPageContext;

  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
      tags: normalizeTags(props.booking.tags),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.booking.tags !== this.props.booking.tags && this.props.openedPopup !== 'TagsModal') {
      this.setState({ tags: normalizeTags(this.props.booking.tags) });
    }
  }

  onValidateForm = async () => {
    const tags = normalizeTags(this.state.tags);

    try {
      this.setState({ confirmLoading: true, tags });
      await updateBookingTags(this.props.booking.bookingId, tags);
      this.context.setTags(tags);
      message.success('The tags were successfully updated.');
      this.setState({ confirmLoading: false, tags });
      this.props.closePopup();
    } catch (error) {
      message.error(get(error, 'response.data.message', error.message));
      this.setState({ confirmLoading: false });
    }
  };

  handleChange = (value) => this.setState({ tags: normalizeTags(value) });

  cancel = () => {
    this.setState({ tags: normalizeTags(this.props.booking.tags), confirmLoading: false });
    this.props.closePopup();
  };

  render() {
    const { openedPopup } = this.props;
    const { tags } = this.state;

    const defaultTags = [
      'test',
      'complaint',
      '2nd-booking',
      'customer-refund',
      'pricing-error',
      'red-flag',
      'mandatory-upsell-declined',
      'advisories-upsell-declined',
      'splitit-plan',
      'manual-installments-unpaid',
      'manual-installments-paid',
      'bad-debt',
      'driver-car-wash',
      'irregular-booking',
      'offline-quote',
      'virtual-consultation',
      'stayover',
    ];

    return (
      <Modal
        title="Tag Booking"
        visible={openedPopup === 'TagsModal'}
        onOk={this.onValidateForm}
        onCancel={this.cancel}
        okText="Save"
        confirmLoading={this.state.confirmLoading}
      >
        <Form>
          <Form.Item>
            <Select
              mode="multiple"
              defaultValue={tags}
              placeholder="Start typing..."
              onChange={this.handleChange}
              value={tags}
            >
              {defaultTags.map((tag) => (
                <Option key={tag}>{tag}</Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(TagsModal);
